import {
  computeItemIdentifier,
  Configuration,
} from '@o3r/core';
import {
  BackToMmbPresConfig,
} from '@refx/servicing-components';

export interface CustomBackToMmbPresConfig extends Configuration {
  /** Code of the airline */
  airlineCode: string;
}

export interface CustomMergedBackToMmbPresConfig extends BackToMmbPresConfig, CustomBackToMmbPresConfig {}

export const CUSTOM_BACK_TO_MMB_PRES_DEFAULT_CONFIG: CustomBackToMmbPresConfig = {
  airlineCode: ''
};

export const CUSTOM_BACK_TO_MMB_PRES_CONFIG_ID = computeItemIdentifier('CustomBackToMmbPresConfig', '@refx/servicing');
